import { Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

const StepTitle = styled(Typography).attrs((props) => ({
  as: "h4",
  color: "black",
  fontSize: 18,
  ...props.theme.diamondSelector.stepTitle,
}))`
  align-items: center;
  display: flex;
  margin-bottom: 8px;
`

const StepIcon = styled.div`
  border: 2px solid ${(props) => props.theme.colors.black};
  border-radius: 50%;
  font-size: 18px;
  height: 24px;
  line-height: 20px;
  margin-right: 8px;
  text-align: center;
  width: 24px;
`

const InternalHeading = ({ showStep, isDiamond, currentStepName }) => {
  if (["confirm_gemstone", "final_diamond"].includes(currentStepName)) {
    return null
  }
  const stepTitle = {
    choose_gemstone: "Gemstone",
    choose_stone_type: "Stone Type",
    d_carat: isDiamond ? "Stone Weight" : "Stone Size",
    d_shape: "Stone Shape",
  }
  return (
    <StepTitle id={`diamond-selector-${currentStepName}`}>
      <StepIcon>{showStep + 1}</StepIcon> Choose Your{" "}
      {stepTitle[currentStepName] || "Quality"}
    </StepTitle>
  )
}

const mapStateToProps = (state) => {
  const currentStepIndex = state.diamondUI.currentStep
  const maxStep = state.diamondUI.steps.includes("choose_stone_type") ? 3 : 2
  const isDiamond = state.choices.d_stone_type?.value?.includes("DIAM")
  return {
    currentStepName: state.diamondUI.steps[currentStepIndex],
    isDiamond,
    showStep: Math.min(state.diamondUI.currentStep, maxStep),
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalHeading.propTypes = {
  currentStepName: PropTypes.string,
  isDiamond: PropTypes.bool,
  showStep: PropTypes.number,
}

const Heading = connect(mapStateToProps, mapDispatchToProps)(InternalHeading)

export default Heading
